import { useTranslation } from 'react-i18next';
import { Group } from '../../../api/groups';
import { GroupModuleYearUnwind } from '../../../api/my-groups';

import Pill from '@pelckmans/elementis/components/pill';
import PillGroup from '@pelckmans/elementis/components/pill-group';
import UsersIcon from '@pelckmans/elementis/icons/users';
import MaterialMediaIcon from '@pelckmans/elementis/icons/material-media';

type StatusPillsProps = {
  group: Group;
  linkedModules: GroupModuleYearUnwind[];
};

export default function StatusPillsCodeBased({ group, linkedModules }: StatusPillsProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <PillGroup role="group" aria-label={t('PAGES.MY_GROUPS.LIST_GROUP.GROUP_INFORMATION.A11Y_LABEL')} size="sm">
      <Pill
        key="accepted"
        icon={<UsersIcon data-testid="users-icon" />}
        prominence="success"
        aria-label={t('PAGES.MY_GROUPS.LIST_GROUP.GROUP_INFORMATION.MEMBERS.A11Y_LABEL')}
      >
        {String(group.totalAccepted)}
      </Pill>
      <Pill
        prominence="neutral"
        icon={<MaterialMediaIcon data-testid="material-media-icon" />}
        aria-label={t('PAGES.MY_GROUPS.LIST_GROUP.GROUP_INFORMATION.MATERIAL.A11Y_LABEL')}
      >
        {linkedModules.length}
      </Pill>
    </PillGroup>
  );
}
